import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION6: PdfComponent = {
  type: 'section',
  id: 's1s6',
  title: '6. Co-operation Between the Parties',
  content: [
    {
      type: 'altText',
      id: 's1s6heading',
      content: ['Each party shall, as reasonably necessary:'],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's1s6bullets',
      bulletType: 'alpha',
      content: [
        {
          copy: 'in its role as Data Controller, use reasonable endeavours to agree with the other party on any required instructions to be provided to Data Processors handling Personal Information; and',
        },
        {
          copy: 'co-operate in good faith and with due diligence to resolve any issue or dispute relating to the Processing of Personal Information in a manner that ensures continuing compliance with Data Privacy Laws and minimises operational disruption.',
        },
      ],
    },
  ],
};
